module.exports = __webpack_public_path__ + "img/trip(7).0e022cdd.webp";